import Cookies from 'js-cookie'
import {RootModel} from "./index";
import {pathToRegexp} from "path-to-regexp";
import * as api from "../apis/auth";
import * as todoApi from "../apis/sysTodo";

import rs from "../routes";
import {createModel} from "@rematch/core";


interface AuthState {
    userToken?: string
    menus: Array<SysResource>
    routes: Routes,
    user?: SysUser,
    todoCount: number
}

const initState: AuthState = {
    userToken: Cookies.get('userToken'),
    menus: [],
    routes: {},
    user: undefined,
    todoCount: 0
}

export const auth = createModel<RootModel>()({
    state: initState,
    reducers: {
        setUserToken: (state: AuthState, payload: string | undefined) => ({...state, userToken: payload}),
        setTodoCount: (state: AuthState, payload: number) => ({...state, todoCount: payload}),
        setUserInfo: (state: AuthState, payload: {
            user?: SysUser,
            menus: Array<SysResource>,
            routes: Routes
        } | undefined) => ({
            ...state, ...payload
        })
    },
    effects: (dispatch) => ({
        async login({userName, password, session, captcha, remember}: {
            userName: string,
            password: string,
            session: string,
            captcha: string,
            remember?: boolean,
        }) {
            const response = await api.login(userName, password, session, captcha)
            const token = response.data.data
            dispatch.auth.setUserToken(token)
            Cookies.set('userToken', token, remember ? {expires: 365} : {})
        },
        async logout() {
            Cookies.remove('userToken')
            dispatch.auth.setUserInfo({user: undefined, menus: [], routes: {}})
            dispatch.auth.setUserToken(undefined)
            window.localStorage.clear()
        },
        async getUserInfo() {
            const response = await api.getUserInfo()
            const {resources, user} = response.data.data
            const menus = flatMenus(generateMenus(resources))
            const routes = generateRoutes(menus, rs)
            dispatch.auth.setUserInfo({user: user, menus: resources, routes: routes})
            this.getTodos().then()
        },
        async getTodos() {
            const response = await todoApi.getNotReadTodosCount()
            const count = response.data.data
            dispatch.auth.setTodoCount(count)
        }
    })
})


function generateMenus(menus: Array<SysResource>, parentPath: string = '/'): Array<SysResource> {
    return menus.map(item => {
        item.path = item.path.startsWith("/") ? '/' + item.path : parentPath + item.path
        if (item.children) {
            const resources = item.children
            if (resources) {
                item.resources = resources.map(i => i.path)
            }
            const children = item.children.filter(i => i.type === 0)
            if (children.length > 0) {
                item.children = generateMenus(item.children, item.path + '/')
            } else {
                delete item.children
            }
        }
        return item
    })
}

type MenuResource = { [path: string]: SysResource }

function flatMenus(menus: Array<SysResource>): MenuResource {
    let keys: MenuResource = {}
    menus.forEach(item => {
        item = {...item}
        const children = item.children
        if (children) {
            delete item.children
            keys = {...keys, ...flatMenus(children)}
        }
        keys[item.path] = {...item}
    })
    return keys
}

function generateRoutes(menus: MenuResource, routes: Routes): Routes {
    Object.keys(menus).forEach(path => {
        const pathRegexp = pathToRegexp(path)
        const routePath = Object.keys(routes).find(routePath => pathRegexp.test(routePath))
        if (routePath) {
            routes[routePath] = {...routes[routePath], ...menus[path]}
        } else {
            routes[path] = {...menus[path]}
        }
    })
    return routes
}
